import React, { useEffect } from "react";
import "./ShareFooter.scss";

function Footer() {
  useEffect(() => {
    const klaviyoScript = document.createElement("script");
    klaviyoScript.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=WyRcrG`;
    klaviyoScript.type = "text/javascript";

    const containerFooter = document.getElementById("container-footer");
    if (containerFooter) {
      containerFooter.appendChild(klaviyoScript);
    } else {
      console.error("Element with ID 'container-footer' not found.");
    }
  }, []);

  return (
    <div className="footerBackground" id="container-footer">
      <div className="footerContainer">
        <div className="footerInnerWrap">
          <div className="leftWrap">
            <div className="footerLinksMainWrap">
              <div className="footerPageLinksCol">
                <div className="footerPageLinksHeader">About</div>
                <div className="footerPageLinks">
                  <a
                    href="https://virtuix.com/about"
                    className="footerLinkWhite"
                  >
                    Who We Are
                  </a>
                </div>
                <div className="footerPageLinks">
                  <a
                    href="https://virtuix.com/press"
                    className="footerLinkWhite"
                  >
                    Press
                  </a>
                </div>
                <div className="footerPageLinks">
                  <a
                    href="https://virtuix.com/careers"
                    className="footerLinkWhite"
                  >
                    Careers
                  </a>
                </div>
                <div className="footerPageLinks">
                  <a
                    href="https://virtuix.com/investors"
                    className="footerLinkWhite"
                  >
                    Investors
                  </a>
                </div>
                <div className="footerPageLinks">
                  <a
                    href="https://developers.virtuix.com/"
                    className="footerLinkWhite"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Developers
                  </a>
                </div>
              </div>
              <div className="footerPageLinksCol">
                <div className="footerPageLinksHeader">Enterprise</div>
                <div className="footerPageLinks">
                  <a
                    href="https://virtuix.com/omni-one-enterprise"
                    className="footerLinkWhite"
                  >
                    Omni One Enterprise
                  </a>
                </div>
                <div className="footerPageLinks">
                  <a
                    href="https://virtuix.com/commercial-inquiries"
                    className="footerLinkWhite"
                  >
                    Omni Arena Inquiries
                  </a>
                </div>
                <div className="footerPageLinks">
                  <a
                    href="https://virtuix.com/case-studies"
                    className="footerLinkWhite"
                  >
                    Omni Arena Case Studies
                  </a>
                </div>
                <div className="footerPageLinks">
                  <a
                    href="https://virtuix.com/omni-pro"
                    className="footerLinkWhite"
                  >
                    Omni Pro
                  </a>
                </div>
                <div className="footerPageLinks">
                  <a
                    href="https://virtuix.com/blogs/news"
                    className="footerLinkWhite"
                  >
                    News
                  </a>
                </div>
              </div>
              <div className="footerPageLinksCol">
                <div className="footerPageLinksHeader">
                  <div className="socialMarginTop">Resources</div>
                </div>
                <div className="socialMenu">
                  <a
                    href="https://www.facebook.com/VirtuixOmni"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <svg
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 12C0 5.37258 5.37258 0 12 0H20C26.6274 0 32 5.37258 32 12V20C32 26.6274 26.6274 32 20 32H12C5.37258 32 0 26.6274 0 20V12Z"
                        fill="white"
                        fillOpacity="0.1"
                      />
                      <path
                        d="M0.5 12C0.5 5.64873 5.64873 0.5 12 0.5H20C26.3513 0.5 31.5 5.64873 31.5 12V20C31.5 26.3513 26.3513 31.5 20 31.5H12C5.64873 31.5 0.5 26.3513 0.5 20V12Z"
                        stroke="white"
                        strokeOpacity="0.3"
                      />
                      <path
                        d="M14.9582 22.5789V17.9206H13.265V15.9931H14.9582V14.524C14.9582 12.8524 15.9538 11.9299 17.4763 11.9299C18.2057 11.9299 18.9689 12.0602 18.9689 12.0602V13.7009H18.1279C17.2992 13.7009 17.0413 14.2156 17.0413 14.7424V15.9931H18.8901L18.5948 17.9206H17.0413V22.5788C20.2285 22.0788 22.6663 19.3206 22.6663 15.9931C22.6663 12.3112 19.6816 9.32642 15.9997 9.32642C12.3178 9.32642 9.33301 12.3112 9.33301 15.9931C9.33301 19.3207 11.771 22.0789 14.9582 22.5789Z"
                        fill="white"
                      />
                    </svg>
                  </a>

                  <a
                    href="https://www.instagram.com/virtuixomni/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <svg
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 12C0 5.37258 5.37258 0 12 0H20C26.6274 0 32 5.37258 32 12V20C32 26.6274 26.6274 32 20 32H12C5.37258 32 0 26.6274 0 20V12Z"
                        fill="white"
                        fillOpacity="0.1"
                      />
                      <path
                        d="M0.5 12C0.5 5.64873 5.64873 0.5 12 0.5H20C26.3513 0.5 31.5 5.64873 31.5 12V20C31.5 26.3513 26.3513 31.5 20 31.5H12C5.64873 31.5 0.5 26.3513 0.5 20V12Z"
                        stroke="white"
                        strokeOpacity="0.3"
                      />
                      <path
                        d="M13.5151 10.042C12.8767 10.0721 12.4407 10.174 12.0596 10.3237C11.6651 10.4774 11.3308 10.6837 10.9982 11.0176C10.6655 11.3514 10.4607 11.686 10.3081 12.081C10.1603 12.463 10.0603 12.8993 10.0321 13.5381C10.0038 14.1768 9.99761 14.3822 10.0007 16.0115C10.0038 17.6409 10.011 17.8452 10.042 18.4853C10.0725 19.1235 10.174 19.5594 10.3238 19.9406C10.4777 20.3351 10.6838 20.6693 11.0177 21.002C11.3517 21.3348 11.686 21.5392 12.082 21.6921C12.4636 21.8395 12.9001 21.9401 13.5387 21.9681C14.1774 21.996 14.3829 22.0025 16.0118 21.9994C17.6407 21.9963 17.8458 21.9891 18.4858 21.9587C19.1258 21.9283 19.5593 21.8261 19.9407 21.6771C20.3351 21.5227 20.6696 21.317 21.0021 20.983C21.3346 20.6489 21.5393 20.3141 21.6919 19.9188C21.8397 19.5372 21.9401 19.1007 21.9679 18.4626C21.9958 17.8221 22.0024 17.6176 21.9993 15.9885C21.9962 14.3594 21.9889 14.1551 21.9585 13.5153C21.9281 12.8754 21.8265 12.4409 21.6769 12.0594C21.5227 11.665 21.3169 11.331 20.983 10.998C20.6492 10.665 20.3141 10.4604 19.919 10.3082C19.5371 10.1605 19.1009 10.0598 18.4623 10.0322C17.8236 10.0046 17.6181 9.99756 15.9886 10.0007C14.3591 10.0038 14.1551 10.0108 13.5151 10.042ZM13.5852 20.8886C13.0002 20.8632 12.6825 20.766 12.4708 20.6846C12.1905 20.5766 11.9908 20.4461 11.7799 20.2372C11.5689 20.0282 11.4393 19.8278 11.3299 19.5481C11.2477 19.3364 11.1487 19.0191 11.1213 18.4341C11.0915 17.8019 11.0853 17.612 11.0818 16.0101C11.0783 14.4082 11.0845 14.2186 11.1122 13.5861C11.1371 13.0016 11.2349 12.6836 11.3162 12.472C11.4242 12.1913 11.5543 11.992 11.7637 11.7811C11.9731 11.5703 12.1729 11.4405 12.4528 11.331C12.6643 11.2485 12.9816 11.1503 13.5663 11.1225C14.1991 11.0925 14.3887 11.0865 15.9904 11.083C17.592 11.0795 17.7821 11.0855 18.4151 11.1133C18.9996 11.1388 19.3178 11.2356 19.5291 11.3173C19.8095 11.4253 20.0091 11.5551 20.2199 11.7648C20.4308 11.9746 20.5607 12.1737 20.6702 12.4542C20.7529 12.6651 20.851 12.9822 20.8786 13.5674C20.9087 14.2001 20.9156 14.3899 20.9185 15.9914C20.9213 17.5929 20.9157 17.7831 20.888 18.4154C20.8624 19.0004 20.7655 19.3182 20.684 19.5301C20.576 19.8103 20.4458 20.0101 20.2362 20.2208C20.0267 20.4316 19.8272 20.5614 19.5471 20.6708C19.3359 20.7533 19.0182 20.8517 18.4339 20.8795C17.8012 20.9093 17.6116 20.9155 16.0093 20.919C14.4071 20.9225 14.2179 20.916 13.5852 20.8886ZM18.4765 12.7932C18.4768 12.9356 18.5192 13.0748 18.5986 13.1931C18.6779 13.3113 18.7905 13.4034 18.9222 13.4577C19.0539 13.512 19.1987 13.526 19.3383 13.498C19.4779 13.4699 19.6061 13.4011 19.7066 13.3002C19.8071 13.1993 19.8755 13.0709 19.903 12.9312C19.9305 12.7914 19.916 12.6467 19.8612 12.5152C19.8065 12.3838 19.714 12.2715 19.5954 12.1926C19.4768 12.1137 19.3375 12.0717 19.1951 12.072C19.0042 12.0724 18.8212 12.1486 18.6865 12.2838C18.5517 12.4191 18.4762 12.6023 18.4765 12.7932ZM12.9193 16.006C12.9226 17.7076 14.3046 19.0839 16.0058 19.0807C17.7071 19.0775 19.0844 17.6956 19.0811 15.994C19.0779 14.2924 17.6956 12.9158 15.9941 12.9191C14.2926 12.9225 12.916 14.3047 12.9193 16.006ZM14 16.0039C13.9992 15.6083 14.1158 15.2214 14.3349 14.892C14.554 14.5627 14.8659 14.3057 15.231 14.1536C15.5962 14.0015 15.9983 13.9611 16.3864 14.0375C16.7745 14.1139 17.1313 14.3037 17.4115 14.5829C17.6918 14.862 17.883 15.218 17.9609 15.6058C18.0389 15.9937 18.0001 16.3959 17.8494 16.7616C17.6987 17.1274 17.443 17.4403 17.1145 17.6607C16.7861 17.8811 16.3996 17.9992 16.004 18C15.7414 18.0005 15.4812 17.9493 15.2383 17.8493C14.9954 17.7493 14.7746 17.6024 14.5885 17.417C14.4025 17.2317 14.2547 17.0115 14.1537 16.769C14.0527 16.5265 14.0005 16.2665 14 16.0039Z"
                        fill="white"
                      />
                    </svg>
                  </a>

                  <a
                    href="https://www.youtube.com/user/VirtuixOmni?view_as=subscriber"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <svg
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 12C0 5.37258 5.37258 0 12 0H20C26.6274 0 32 5.37258 32 12V20C32 26.6274 26.6274 32 20 32H12C5.37258 32 0 26.6274 0 20V12Z"
                        fill="white"
                        fillOpacity="0.1"
                      />
                      <path
                        d="M12 0.5H20C26.3513 0.5 31.5 5.64873 31.5 12V20C31.5 26.3513 26.3513 31.5 20 31.5H12C5.64873 31.5 0.5 26.3513 0.5 20V12C0.5 5.64873 5.64873 0.5 12 0.5Z"
                        stroke="white"
                        strokeOpacity="0.3"
                      />
                      <path
                        d="M14.6663 17.9999L18.1263 15.9999L14.6663 13.9999V17.9999ZM22.373 12.7799C22.4597 13.0933 22.5197 13.5133 22.5597 14.0466C22.6063 14.5799 22.6263 15.0399 22.6263 15.4399L22.6663 15.9999C22.6663 17.4599 22.5597 18.5333 22.373 19.2199C22.2063 19.8199 21.8197 20.2066 21.2197 20.3733C20.9063 20.4599 20.333 20.5199 19.453 20.5599C18.5863 20.6066 17.793 20.6266 17.0597 20.6266L15.9997 20.6666C13.2063 20.6666 11.4663 20.5599 10.7797 20.3733C10.1797 20.2066 9.79301 19.8199 9.62634 19.2199C9.53967 18.9066 9.47967 18.4866 9.43967 17.9533C9.39301 17.4199 9.37301 16.9599 9.37301 16.5599L9.33301 15.9999C9.33301 14.5399 9.43967 13.4666 9.62634 12.7799C9.79301 12.1799 10.1797 11.7933 10.7797 11.6266C11.093 11.5399 11.6663 11.4799 12.5463 11.4399C13.413 11.3933 14.2063 11.3733 14.9397 11.3733L15.9997 11.3333C18.793 11.3333 20.533 11.4399 21.2197 11.6266C21.8197 11.7933 22.2063 12.1799 22.373 12.7799Z"
                        fill="white"
                      />
                    </svg>
                  </a>

                  <a
                    href="https://x.com/virtuixomni"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <svg
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 12C0 5.37258 5.37258 0 12 0H20C26.6274 0 32 5.37258 32 12V20C32 26.6274 26.6274 32 20 32H12C5.37258 32 0 26.6274 0 20V12Z"
                        fill="white"
                        fillOpacity="0.1"
                      />
                      <path
                        d="M12 0.5H20C26.3513 0.5 31.5 5.64873 31.5 12V20C31.5 26.3513 26.3513 31.5 20 31.5H12C5.64873 31.5 0.5 26.3513 0.5 20V12C0.5 5.64873 5.64873 0.5 12 0.5Z"
                        stroke="white"
                        strokeOpacity="0.3"
                      />
                      <path
                        d="M17.1428 15.0817L21.6108 10H20.5524L16.6712 14.4115L13.5736 10H10L14.6852 16.6716L10 22H11.0584L15.1544 17.3403L18.4264 22H22M11.4404 10.781H13.0664L20.5516 21.2574H18.9252"
                        fill="white"
                      />
                    </svg>
                  </a>

                  <a
                    href="https://www.tiktok.com/@virtuixomni"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <svg
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 12C0 5.37258 5.37258 0 12 0H20C26.6274 0 32 5.37258 32 12V20C32 26.6274 26.6274 32 20 32H12C5.37258 32 0 26.6274 0 20V12Z"
                        fill="white"
                        fillOpacity="0.1"
                      />
                      <path
                        d="M0.5 12C0.5 5.64873 5.64873 0.5 12 0.5H20C26.3513 0.5 31.5 5.64873 31.5 12V20C31.5 26.3513 26.3513 31.5 20 31.5H12C5.64873 31.5 0.5 26.3513 0.5 20V12Z"
                        stroke="white"
                        strokeOpacity="0.3"
                      />
                      <path
                        d="M20.2637 12.0059C19.5456 11.5375 19.0271 10.7884 18.8654 9.91503C18.8305 9.72624 18.8113 9.53212 18.8113 9.33331H16.519L16.5152 18.5201C16.4767 19.5488 15.6301 20.3745 14.592 20.3745C14.2694 20.3745 13.9655 20.2939 13.6981 20.153C13.0848 19.8302 12.6652 19.1873 12.6652 18.4475C12.6652 17.3849 13.5296 16.5205 14.592 16.5205C14.7903 16.5205 14.9805 16.5532 15.1606 16.6095V14.2693C14.9742 14.2439 14.785 14.2281 14.592 14.2281C12.2658 14.2283 10.373 16.1211 10.373 18.4475C10.373 19.875 11.0863 21.1381 12.1743 21.9019C12.8595 22.383 13.6932 22.6666 14.5922 22.6666C16.9186 22.6666 18.8113 20.7739 18.8113 18.4475V13.7891C19.7103 14.4345 20.8118 14.8147 22.0004 14.8147V12.5224C21.3602 12.5224 20.7638 12.332 20.2637 12.0059Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </div>
                <div className="footerPageLinks">
                  <a
                    href="https://virtuix.com/creators"
                    className="footerLinkWhite"
                  >
                    Creators
                  </a>
                </div>
                <div className="footerPageLinks">
                  <a
                    href="https://support.virtuix.com/hc/en-us"
                    className="footerLinkWhite"
                  >
                    Support
                  </a>
                </div>
                <div className="footerPageLinks">
                  <a
                    href="https://virtuix.com/financing"
                    className="footerLinkWhite"
                  >
                    Financing
                  </a>
                </div>
                <div className="footerPageLinks">
                  <a
                    href="https://virtuix.com/pc"
                    className="footerLinkWhite"
                  >
                    Omni Connect
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="rightWrap">
            <div className="footerColumn">
              <div className="newsletterBox">
                <div className="klaviyo-form-YccSsC"></div>
                <div className="newsletterLegalText">
                  By signing up you are agreeing to the Virtuix{" "}
                  <a href="https://virtuix.com/terms-of-use">Terms of Use</a>{" "}
                  and Virtuix{" "}
                  <a href="https://virtuix.com/privacy-policy">
                    Privacy Policy
                  </a>
                  .<br />
                  You may unsubscribe at any time.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="secondaryFooterContainer">
        <div className="secondaryFooterColumn">
          <div className="secondaryLeftWrap">
            <div className="footerColumn">
              <div className="footerLegalText">
                Copyright © Virtuix ™ 2025. All rights reserved.
              </div>
            </div>
          </div>
          <div className="secondaryRightWrap">
            <div className="footerColumn">
              <div className="footerLegalTextLinks">
                <a
                  className="footerLinkGray"
                  href="https://support.virtuix.com/"
                >
                  Support
                </a>
              </div>
            </div>
            <div className="footerColumn">
              <div className="footerLegalTextLinks">
                <a className="footerLinkGray" href="https://virtuix.com/legal">
                  Legal
                </a>
              </div>
            </div>
            <div className="footerColumn">
              <div className="footerLegalTextLinks">
                <a
                  className="footerLinkGray"
                  href="https://virtuix.com/terms-of-sale"
                >
                  Terms of Sale
                </a>
              </div>
            </div>
            <div className="footerColumn">
              <div className="footerLegalTextLinks">
                <a
                  className="footerLinkGray"
                  href="https://virtuix.com/privacy-policy"
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
